import React from "react";

import Header from "../layout/Header";
import "./index.scss";

const SlideContact = () => {
  return (
    <div className="slide-contact">
      <Header />
      <div className="slide-contact-container ">
        <div className="row w-100 d-flex align-items-end h-100 mb-5"></div>
      </div>
    </div>
  );
};


export default SlideContact;
